var path = 'public/app/features/panel/partials/soloPanel.html';
var html = "<div class=panel-solo ng-if=panel>\n\t<plugin-component type=panel>\n\t</plugin-component>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;